export default __webpack_public_path__ + "static/media/camera.9c31fe06.PNG";